export const errorStyle = {
  error: {
    color: 'error.main',
    variant: 'caption',
    backgroundColor: 'rgba(209, 67, 67, 0.12)',
    sx: {
      ml: 2,
    },
    dividerError: {
      border: '1px solid #D14343',
    },
  },
};
